import { useEffect, useState } from "react";
import { useParams } from "react-router";
import { useHistory, Link } from 'react-router-dom';

import Toast from '../toast';
import { getEndpoint } from "../helper";
import { cookie } from 'shared-kernel/helpers';

export default function Verify(props) {
    const history = useHistory();
    const [code, setCode] = useState('');
    const [timer, setTimer] = useState(90);
    const [buttonClassName, setButtonClassName] = useState('_bc-g-g');
    const [isValid, setIsValid] = useState(false);
    const [showToast, setShowToast] = useState(false);
    const { mobile } = useParams();

    const handleMobileChange = e => {
        const { value, maxLength } = e.target;
        const code = value.slice(0, maxLength);

        setCode(code);

        if (code.length === 4) {
            setButtonClassName('_bc-g');
            setIsValid(true);
        }
        else {
            setButtonClassName('_bc-g-g');
            setIsValid(false);
        }
    }

    const handleClick = () => {
        if (isValid) {
            fetch(getEndpoint(`/api/android/auth/validatecode?code=${code}&mobile=${mobile}`), { credentials: "include" })
                .then(res => {
                    if (res.ok) history.push('/');
                    else {
                        setShowToast(true);
                        setTimeout(() => setShowToast(false), 4000);
                    }
                });
        }
    }

    useEffect(() => {
        const fetchData = async () => {
            try {
                const response = await fetch(getEndpoint("/api/android/auth/getcookie"), { credentials: "include" });
                if (response.ok) {
                    history.push('/');
                    return;
                }
            } catch (err) {
                console.log(err.message);
            } finally {
            }
        };

        fetchData();
    }, []);

    useEffect(() => {
        const timerInterval = setInterval(() => {
            setTimer((prevTimer) => {
                if (prevTimer <= 1) {
                    clearInterval(timerInterval);
                    return 0;
                }
                return prevTimer - 1;
            });
        }, 1000);

        return () => clearInterval(timerInterval);
    }, []);

    return (
        <div className="d-f ai-c jc-c h-100vh px-4" style={{ backgroundColor: '#fafafa' }}>
            <div className="w-100">
                <img style={{ width: '10rem' }} className="mx-a" src={getEndpoint('/pwa/img/logo.png')} alt="تامین 360" />
                <div className="ta-c mt-5 mb-4"
                    children={`رمز موقت ارسالی به شماره ${mobile} را وارد نمایید.`}
                />
                <div className='ta-c mb-4'>
                    <Link to="/signin" className="_c-g">تصحیح شماره همراه</Link>
                </div>
                <div className='auth-wrap p-r'>
                    <input name="mobile"
                        className="auth br-4 bw-1 bc--n3 ta-c f:o-n w-100 py-2"
                        pattern="\d*"
                        type="number"
                        maxLength="4"
                        placeholder="کد ارسالی"
                        value={code}
                        onChange={handleMobileChange} />
                    <button
                        onClick={handleClick}
                        className={`${buttonClassName} c-w d-f ai-c jc-c w-100 br-4 py-2 us-n mt-4`}
                        children='تایید رمز موقت' />

                    <div className="_c-g p-a" style={{ left: '.7rem', top: '.85rem' }}>
                        <span children={timer} />&nbsp;ثانیه
                    </div>
                </div>
            </div>

            <Toast show={showToast} message='کد وارد شده معتبر نیست!' />
        </div>
    )
}